<template>
    <base-nav
        container-classes="container-fluid"
        class="navbar-top navbar-expand"
        :class="{'bg-gradient-info navbar-dark': type === 'default'}">
        <button
            type="button"
            class="mobile-sidenav-toggler"
            @click="minimizeSidebar">
            <div class="sidenav-toggler-inner">
                <i class="sidenav-toggler-line"></i>
                <i class="sidenav-toggler-line"></i>
                <i class="sidenav-toggler-line"></i>
            </div>
        </button>
        <base-dropdown class="navbar-nav align-items-center ml-md-auto language-selector-dropdown" menuOnRight>
            <base-button slot="title-container" type="clean" class="dropdown-toggle text-white">
                {{ $t('general.language') }}
            </base-button>
            <button
                v-for="lang in languages"
                :key="lang.id"
                :class="{active: lang.id === user.language.id}"
                class="dropdown-item ai"
                @click="updateLanguage(lang)">{{ $t('languages.' + lang.code) }}
            </button>
        </base-dropdown>
        <base-dropdown class="navbar-nav align-items-center" menuOnRight>
            <base-button slot="title-container" type="clean" class="dropdown-toggle text-white">
                {{ user.name || user.email }}
            </base-button>
            <router-link to="/my-account" class="dropdown-item">
                <i class="ai ai-account text-warning"></i> {{ $t('sideMenu.myAccount') }}
            </router-link>
            <button class="dropdown-item" @click="logout">
                <i class="ai ai-logout text-primary"></i> {{ $t('general.logout') }}
            </button>
        </base-dropdown>
    </base-nav>
</template>
<script>
    import {CollapseTransition} from 'vue2-transitions';
    import {BaseNav, Modal} from '@/components';
    import {mapGetters, mapActions, mapMutations} from 'vuex'

    export default {
        components: {
            CollapseTransition,
            BaseNav,
            Modal
        },
        props: {
            type: {
                type: String,
                default: 'default', // default|light
                description: 'Look of the dashboard navbar. Default (Green) or light (gray)'
            }
        },
        computed: {
            ...mapGetters({
                user: 'getUser'
            }),
            routeName() {
                const {name} = this.$route;
                return this.capitalizeFirstLetter(name);
            }
        },
        data() {
            return {
                languages: [],
                activeNotifications: false,
                showMenu: false,
                searchModalVisible: false,
                searchQuery: ''
            };
        },
        methods: {
            ...mapActions({
                logout: 'logout',
                refreshUser: 'refreshUser',
            }),
            ...mapMutations({
                setUser: 'setUser'
            }),
            capitalizeFirstLetter(string) {
                return string.charAt(0).toUpperCase() + string.slice(1);
            },
            toggleNotificationDropDown() {
                this.activeNotifications = !this.activeNotifications;
            },
            closeDropDown() {
                this.activeNotifications = false;
            },
            toggleSidebar() {
                this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
            },
            hideSidebar() {
                this.$sidebar.displaySidebar(false);
            },
            updateLanguage(language) {
                this.$axios.post('/api/languages', language)
                    .then(res => {
                        this.refreshUser();
                        document.getElementsByTagName('html')[0].setAttribute('lang', language.code);
                        this.$cookies.set('lang', language.code);
                        this.$i18n.locale = language.code;

                        this.$notify({
                            title: this.$t('languages.languageUpdated'),
                        });
                    })
                    .catch(err => {
                        this.$notify({
                            title: this.$t('general.somethingWentWrong'),
                            type: 'danger',
                        });
                    })
            },
            minimizeSidebar() {
                if (this.$sidebar) {
                    this.$sidebar.toggleMinimize();
                }
            }
        },
        async created() {
            this.languages = (await this.$axios.get('/api/languages')).data;
        },
    };
</script>

<style lang="scss">
    .language-selector-dropdown {
        .dropdown-item {
            position: relative;
            padding: .5rem 1rem .5rem 1.5rem;

            &.active {
                &:before {
                    position: absolute;
                    left: 5px;
                    top: 50%;
                    transform: translateY(-50%);
                    content: "\ea22";
                }
            }
        }
    }

    .mobile-sidenav-toggler {
        display: none;

        @media (max-width: 1199.98px) {
            display: initial;
            border: none;
            background-color: transparent;
            box-shadow: none;

            &:focus {
                outline: none;
            }

            .sidenav-toggler-inner {
                .sidenav-toggler-line {
                    background-color: #fff;
                }
            }
        }
    }
</style>
